import Vue from 'vue'
import Vuex from 'vuex'
import env from "./env"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiDekNerd: env.get("apiDekNerd"),
    api: env.get("api"),
    // apiDekNerd: "https://tula-api-sandbox.deknerd.com/api",
    // api: "http://192.168.1.125/api",
    // serverName: 'TULA',
    serverName: env.get("serverName"),
    readOnly: false,
    showCorrectAnswer: false,
    token: null,
    demoToken: "44fHF5297esAAExkXitVvmYmC3UjGpZGAn2gBSCKB9v",
    everClickDone: true,
    ticketDetail: {
      ticket: null,
      token: null
    },
    finishExamBy: null,
    endPublishDate: null
  },
  getters: {
    isEverClickDone: state => {
      return state.everClickDone;
    },
    getTicket: state => {
      let ticketDetail = {
        ticket: sessionStorage.getItem("ticket") || state.ticketDetail.ticket || null,
        token: sessionStorage.getItem("token") || state.ticketDetail.token || null
      }
      return ticketDetail;
    },
    getFinishExamBy: state => {
      let finishExamBy = sessionStorage.getItem("finishExamBy") || state.finishExamBy || null
      return finishExamBy;
    },
    getEndPublishDate: state => {
      let endPublishDate = sessionStorage.getItem("endPublishDate") || state.endPublishDate || 0
      return endPublishDate;
    },
  },
  mutations: {
    setReadOnly(state, val) {
      state.readOnly = val;
    },
    setToken(state, token) {
      state.token = token;
    },
    setTicket(state, ticketDetail) {
      sessionStorage.setItem("ticket", ticketDetail.ticket)
      sessionStorage.setItem("token", ticketDetail.token)

      state.ticketDetail = {
        ticket: ticketDetail.ticket,
        token: ticketDetail.token
      }
    },
    setFinishExamBy(state, data) {
      sessionStorage.setItem("finishExamBy", data)

      state.finishExamBy = data
    },
    setShowCorrect(state, val) {
      state.showCorrectAnswer = val;
    },
    setEverClickDone(state, val) {
      state.everClickDone = val;
    },
    setEndPublishDate(state, val) {
      state.endPublishDate = val;
    },
  },
  actions: {
  },
  modules: {
  }
})
